import { styled } from 'libs/ui/styled';

export const CountryRiskBadgesStyled = styled('span')(() => ({
  display: 'inline-flex',
  alignItems: 'center',
  flexShrink: 0,
  gap: 2,
}));
